'use strict';

const clearSvg = require('../../images/clear.svg');
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('timesheetsDesktopController', function (docketService, orderService, resourceService, userService, batchService, xeroService, addressBookService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q, $location) {
    mixpanel.track("Opened Timesheets Desktop");

    $scope.clearSvgImagePath = clearSvg;
    /***************************/
    /***** Setup Variables *****/
    /***************************/
    $scope.moment = moment;

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $scope.fullApiPath = DOCKETBOOK_API_URL + "/" + $scope.urlVersion;

    $scope.showFilters = false;
    $scope.preventReloadWithFilters = true;

    $scope.weekStartDay = 'monday';
    var startDayTransform = { 'monday': 1, 'tuesday': 2, 'wednesday': 3, 'thursday': 4, 'friday': 5, 'saturday': 6, 'sunday': 0 };

    // AAEH Custom work week modifier - temporary
    if ($scope.currentOrg && $scope.currentOrg.id == '0135a923-c035-46c0-9d95-f047f797f75e') {
      $scope.weekStartDay = 'friday';
    }

    $scope.weekStartDayNum = startDayTransform[$scope.weekStartDay];

    // Filters initial
    $scope.filters = {};
    $scope.filters.status = "All";
    $scope.filters.startFromDate = moment().startOf('week').add('days', $scope.weekStartDayNum).toDate(); // was 1
    $scope.filters.endToDate = moment().startOf('week').add('days', $scope.weekStartDayNum + 6).toDate(); // was 7
    $scope.filters.author = null;
    $scope.filterHeading = "";
    $scope.activeFilters = 0;

    // New list query pagination
    $scope.query = {
      limit: 30,
      page: 1,
      order: 'date'
    };
    $scope.promise = null;

    // Timesheets data
    $scope.allDockets = [];
    $scope.userSummaries = {};
    $scope.timeDaySummaries = {};
    $scope.allUsers = [];
    $scope.orderedUsers = [];

    $scope.loadUsers = function (cb) {
      userService.getMembers(null, function (users) {
        $scope.allUsers = users;
        cb();
      }, function (err) {
        $scope.allUsers = [];
        cb();
      });
    }

    // Allocations filter go back a week
    $scope.jobAllocationsFiltersBackWeek = function () {
      var startWeek = moment($scope.filters.startFromDate).subtract('week', 1);
      $scope.filters.endToDate = moment(startWeek).add('days', 6).toDate();
      $scope.filters.startFromDate = startWeek.toDate();
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      $scope.loadDocketsList();
    }

    // Allocations filter go forward a week
    $scope.jobAllocationsFiltersNextWeek = function () {
      var startWeek = moment($scope.filters.startFromDate).add('week', 1);
      $scope.filters.endToDate = moment(startWeek).add('days', 6).toDate();
      $scope.filters.startFromDate = startWeek.toDate();
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      $scope.loadDocketsList();
    }

    // Load Dockets
    $scope.loadDocketsList = function (searchValue, reload) {
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        //params['limit'] = $scope.query.limit;
        //params['offset'] = $scope.query.limit * ($scope.query.page - 1);
        //params['sort'] = $scope.query.order;
        if (searchValue != null && searchValue != "") {
          params['search'] = searchValue;
        }

        docketService.getDockets(params, function (returnData) {
          $scope.userSummaries = {};
          $scope.orderedUsers = [];
          $scope.timeDaySummaries = { 1: { total: 0, travel: 0, break: 0 }, 2: { total: 0, travel: 0, break: 0 }, 3: { total: 0, travel: 0, break: 0 }, 4: { total: 0, travel: 0, break: 0 }, 5: { total: 0, travel: 0, break: 0 }, 6: { total: 0, travel: 0, break: 0 }, 7: { total: 0, travel: 0, break: 0 } };
          var docketsListParsed = docketService.parseDockets(returnData);
          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.allDockets = returnData;

          // categories dockets by members
          for (var i = 0; i < $scope.allDockets.length; i++) {
            var thisDocket = $scope.allDockets[i];
            if (thisDocket.status != 'Draft' && thisDocket.status != 'Rejected') {
              if (!$scope.userSummaries[thisDocket.author]) {
                $scope.userSummaries[thisDocket.author] = { dockets: [], totalSummary: {}, docketSummaries: {}, daySummaries: { 1: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 2: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 3: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 4: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 5: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 6: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 7: { totalWorked: 0, travelTime: 0, breakTime: 0 } } };
              }
              $scope.userSummaries[thisDocket.author].dockets.push(thisDocket);
              // get time summary for this docket
              var totalMinutes = 0;
              var hasBothTimes = false;
              if (thisDocket.startTime && thisDocket.endTime) {
                var startTime = moment(thisDocket.startTime).format('HH:mm');
                var endTime = moment(thisDocket.endTime).format('HH:mm');
                totalMinutes = moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'minutes');
                if (totalMinutes < 0) {
                  totalMinutes = totalMinutes + 24 * 60
                }
                hasBothTimes = true;
              }
              var summary = { totalMinutes };
              if (thisDocket.travelTime != undefined && thisDocket.travelTime >= 0) {
                summary.travelTime = thisDocket.travelTime;
              } else {
                summary.travelTime = 0;
              }
              if (thisDocket.breakTime != undefined && thisDocket.breakTime >= 0) {
                summary.breakTime = thisDocket.breakTime;
              } else {
                summary.breakTime = 0;
              }
              var totalWorked = 0;
              if (hasBothTimes) {
                totalWorked = (totalMinutes - summary.breakTime) + summary.travelTime;
              }
              summary.totalWorked = totalWorked;
              $scope.userSummaries[thisDocket.author].docketSummaries[thisDocket.id] = summary;
              // add to day summaries
              var docketDay = moment(thisDocket.date, 'YYYY-MM-DD').diff(moment($scope.filters.startFromDate), 'days') + 1;
              $scope.userSummaries[thisDocket.author].daySummaries[docketDay].totalWorked += summary.totalWorked;
              $scope.userSummaries[thisDocket.author].daySummaries[docketDay].breakTime += summary.breakTime;
              $scope.userSummaries[thisDocket.author].daySummaries[docketDay].travelTime += summary.travelTime;
              $scope.timeDaySummaries[docketDay].totalWorked += summary.totalWorked;
              $scope.timeDaySummaries[docketDay].breakTime += summary.breakTime;
              $scope.timeDaySummaries[docketDay].travelTime += summary.travelTime;
            }
          }

          // generate user total summaries
          for (var userId in $scope.userSummaries) {
            var totalSummary = { totalMinutes: 0, totalBreak: 0, totalTravel: 0 };
            for (var docketId in $scope.userSummaries[userId].docketSummaries) {
              totalSummary.totalMinutes += $scope.userSummaries[userId].docketSummaries[docketId].totalWorked;
              totalSummary.totalBreak += $scope.userSummaries[userId].docketSummaries[docketId].breakTime;
              totalSummary.totalTravel += $scope.userSummaries[userId].docketSummaries[docketId].travelTime;
            }
            $scope.userSummaries[userId].totalSummary = totalSummary;
          }

          // order users by those with times first
          var usersWithout = [];
          for (var i = 0; i < $scope.allUsers.length; i++) {
            if ($scope.userSummaries[$scope.allUsers[i].id] && $scope.userSummaries[$scope.allUsers[i].id].totalSummary.totalMinutes > 0) {
              $scope.orderedUsers.push($scope.allUsers[i]);
            } else {
              usersWithout.push($scope.allUsers[i]);
            }
          }
          for (var i = 0; i < usersWithout.length; i++) {
            $scope.orderedUsers.push(usersWithout[i]);
          }

          $scope.preventReloadWithFilters = false;
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.formatTimeNice = function (mins) {
      if (!mins) {
        return "0h 0m";
      }
      var hours = Math.floor(mins / 60);
      var minutes = mins % 60;
      return hours + "h " + minutes + "m";
    }

    $scope.expandUserTimesheet = function (userId) {
      if ($("#" + userId).is(":hidden")) {
        $("#" + userId).slideDown();
      } else {
        $("#" + userId).slideUp();
      }
    }

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    $scope.$watch('filters', function () {
      // check toDate is after fromDate
      if (moment($scope.filters.endToDate).isBefore($scope.filters.startFromDate)) {
        $scope.filters.endToDate = $scope.filters.startFromDate;
      }

      // check if status filter has changed
      var storedFilters = JSON.parse(localStorage.getItem('filters'));

      if (!$scope.preventReloadWithFilters) {
        $scope.loadDocketsList();
      }

      localStorage.setItem('filters', JSON.stringify($scope.filters));
    }, true);

    /*** Filters ***/

    $scope.getFilterParams = function () {
      var params = {};
      params.timezone = moment.tz.guess();
      if ($scope.filters.startFromDate != null) {
        var fromDate = moment($scope.filters.startFromDate);
        params.fromDate = fromDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.endToDate != null) {
        var toDate = moment($scope.filters.endToDate);
        params.toDate = toDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.status != 'All') {
        params.status = $scope.filters.status;
      }
      if ($scope.filters.author != null && $scope.filters.author != "") {
        params.authorName = $scope.filters.author;
      }

      return params;
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.selectDate = function (dateObject, field, ev) {
      $mdpDatePicker(dateObject[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        dateObject[field] = selectedDate;
      });
    }

    $scope.showDatePicker = function (field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function (field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function (selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /** Load Initial Dockets List **/
    $scope.loadUsers(function () {
      $scope.loadDocketsList();
    });

  });



// WEBPACK FOOTER //
// ./src/controllers/timesheets/desktopController.js